import axios from 'axios'
export function getFuncTree(data) {
    return axios({
        url: '/user/SysOrganizationWsg/queryTreeList',
        method: 'get',
        data: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function getFunc(data) {
    return axios({
        url: '/user/SysOrganizationWsg/getFunc',
        method: 'post',
        data: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}